export enum SupervisorAddTerritoryColumns {
  name,
  isAdded,
}
